import { RatingPromptWrapperProps } from './index';
import { useEffect, useState } from 'react';
import RatingComponent from './RatingComponent';
import RatingComponentWithPortal from './RatingComponentWithPortal';
import { RatingComponentData, ratingPromptAPI } from 'api/rating';

function RatingComponentPageWrapper({ itemType, itemId, flexedPosition }: RatingPromptWrapperProps) {
    const [showPrompt, setShowPrompt] = useState(false);
    const [promptData, setPromptData] = useState<RatingComponentData>();
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        ratingPromptAPI.getRatingComponentData(itemType, itemId, false).then((response) => {
            if (response.status === 'OK') {
                setShowPrompt(true);
                setPromptData(response.data);
            }

            if (response.status === 'SKIP') {
                setShowPrompt(false);
            }
        });
    }, []);

    const hidePrompt = () => {
        setShowPrompt(false);
    };

    const ratingProps = {
        itemType,
        itemId,
        showPrompt,
        promptData: promptData!,
        hidePrompt,
        expanded,
        setExpanded,
    };

    return showPrompt && promptData ? (
        flexedPosition ? (
            <RatingComponent {...ratingProps} flexedPosition={flexedPosition} />
        ) : (
            <RatingComponentWithPortal {...ratingProps} />
        )
    ) : null;
}

export default RatingComponentPageWrapper;
